module.exports = __webpack_public_path__ + "img/arabulucuproicon.27b39096.svg";